<template>
  <v-dialog
    v-model="visible"
    width="60%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
    content-class="elevation-0"
  >
    <v-card class="rounded-xl">
      <v-card-title v-if="selectRechnung.rechnung_titel">
        <v-chip small v-if="selectRechnung.status === 'Gezahlt'" dark label class="green mr-2">
          {{ selectRechnung.status }}
        </v-chip>
        <v-chip small v-else dark label class="red mr-2">
          {{ selectRechnung.status }}
        </v-chip>
        {{ selectRechnung.rechnung_titel }}
        <v-spacer></v-spacer>
        <buttonRechnungDownload
          class="hidden-xs-only"
          :small="true"
          icon="download"
          :rechnung="selectRechnung"
          v-if="selectRechnung.status !== 'Entwurf' && selectRechnung.status !== 'Entwurf SEPA'"
        />
        <v-btn icon class="hidden-xs-only" @click="close()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="ma-0 pa-0">
        <v-alert outlined color="primary" dismissible class="ma-3" v-if="selectRechnung.log">
          <span class="text-subtitle-2"
            >Rechnung wurde {{ selectRechnung.log.filter((item) => item.type === "Mailversand").length }} mal per Mail
            zugestellt.</span
          >
          <br />
          <span class="text-caption" v-if="selectRechnung.log.filter((item) => item.type === 'Mailversand').length > 0"
            >Zuletzt versendet:
            {{
              $filters.date(
                selectRechnung.log.filter((item) => item.type === "Mailversand").slice(-1)[0].date.seconds * 1000,
                "DD.MM.YYYYhhmm"
              )
            }}
            Uhr</span
          >
        </v-alert>
        <v-row class="ma-0 pa-0 hidden-xs-only mt-n1">
          <v-col cols="12" class="d-flex justify-end mb-n16">
            <v-spacer></v-spacer>
            <v-img :src="logoUrl" height="256px" max-width="256px" class="mb-n16">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="12" class="px-0 mt-12">
            <v-sheet class="primary" height="4"></v-sheet>
            <v-sheet v-if="$vars.verbindung !== 'gfsm'" class="secondary" height="4"></v-sheet>
            <v-sheet v-if="$vars.verbindung !== 'gfsm'" class="tertiary" height="4"></v-sheet>
          </v-col>
          <v-col cols="12" class="mt-n4 mb-0" v-if="settings">
            <span class="caption font-weight-bold">{{ settings.name }}</span>
            <span class="caption"
              >| {{ settings.strasse }} {{ settings.hausnummer }} | {{ settings.plz }} {{ settings.ort }}</span
            >
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col cols="4" md="2">
            <span class="caption font-weight-bold">Rechnungsnr.</span><br />
            <span v-if="selectRechnung.rechnungsnummer">{{ selectRechnung.rechnungsnummer }}</span
            ><br />
          </v-col>
          <v-col cols="4" md="2" v-if="selectRechnung.rechnung_datum">
            <span class="caption font-weight-bold">Rechnungsdatum</span><br />
            <span>{{ $filters.date(selectRechnung.rechnung_datum, "DD.MM.YYYY") }}</span
            ><br />
          </v-col>
          <v-col cols="4" md="2">
            <span class="caption font-weight-bold">Zahlbar bis</span><br />
            <span v-if="selectRechnung.rechnung_zahlbar_bis">{{
              $filters.date(selectRechnung.rechnung_zahlbar_bis, "DD.MM.YYYY")
            }}</span
            ><br />
          </v-col>
          <v-col cols="4" md="2">
            <span class="caption font-weight-bold">Kasse</span><br />
            <span v-if="selectRechnung.kasse">{{ selectRechnung.kasse }}</span
            ><br />
          </v-col>
          <v-col cols="4" md="2">
            <span class="caption font-weight-bold">Rechnungsart</span><br />
            <span v-if="selectRechnung.rechnung_art">{{ selectRechnung.rechnung_art }}</span>
            <span v-else>-</span>
          </v-col>
          <v-col cols="4" md="2">
            <span class="caption font-weight-bold">Gezahlt am</span><br />
            <span v-if="selectRechnung.gezahlt_datum">{{
              $filters.date(selectRechnung.gezahlt_datum, "DD.MM.YYYY")
            }}</span
            ><br />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-textarea
              readonly
              solo
              flat
              auto-grow
              max-rows="15"
              class="pa-1"
              v-if="selectRechnung.rechnung_freitext"
              v-model="selectRechnung.rechnung_freitext"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-expansion-panels flat accordion multiple class="ma-0 pt-0 pb-0" v-if="selectRechnung.positionen">
          <v-expansion-panel
            v-for="(item, itemObjKey) in selectRechnung.positionen"
            :key="item.name"
            :readonly="!item.positionen.length > 0"
          >
            <v-divider></v-divider>
            <v-expansion-panel-header :hide-actions="!item.positionen.length > 0"
              >{{ itemObjKey + 1 }}
              <span class="pl-3">
                {{ item.was }}
              </span>
              <span class="text-right pr-4">
                {{ item.betrag | money }}
              </span>
              <template v-slot:actions>
                <v-icon>keyboard_arrow_down</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="item.positionen">
              <v-card outlined v-if="item.was === 'EKP'">
                <v-card-title class="overline py-0">Zusammenfassung</v-card-title>
                <v-divider></v-divider>
                <v-simple-table dense fixed-header>
                  <tbody>
                    <tr v-for="item in item.result" :key="item.name">
                      <th width="30px">{{ item.anzahl }}x</th>
                      <th v-if="item.was">{{ item.was }}</th>
                      <th class="text-right">{{ item.preis | money }}</th>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
              <v-card outlined class="mt-2">
                <v-card-title v-if="item.was === 'EKP'" class="overline py-0">Einzelauflistung</v-card-title>
                <v-divider v-if="item.was === 'EKP'"></v-divider>
                <v-simple-table dense fixed-header>
                  <tbody>
                    <tr v-for="item in item.positionen" :key="item.name">
                      <td width="130px">{{ $filters.date(item.datum, "DD.MM.YYYY") }}</td>
                      <td v-if="item.anzahl !== undefined">{{ item.anzahl }}</td>
                      <td v-if="item.was">{{ item.was }}</td>
                      <td class="text-right">{{ item.preis | money }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel readonly>
            <v-divider></v-divider>
            <v-expansion-panel-header hide-actions>
              <span class="text-right pr-4 font-weight-bold">
                {{ selectRechnung.summe | money }}
              </span>
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mb-6 mb-md-0">
        <v-btn
          rounded
          text
          class="hidden-xs-only"
          v-if="allowRechnungBearbeiten"
          @click="(showBearbeiten = true) && (bearbeiteRechnung = JSON.parse(JSON.stringify(selectRechnung)))"
          >Bearbeiten</v-btn
        >
        <buttonRechnungSenden
          v-if="selectRechnung.status !== 'Entwurf' && selectRechnung.status !== 'Entwurf SEPA'"
          :small="false"
          icon="outgoing_mail"
          text="Per Mail senden"
          :rechnung="selectRechnung"
        />
        <v-spacer></v-spacer>
        <v-btn
          rounded
          dark
          v-if="allowRechnungBearbeiten && selectRechnung.status !== 'Gezahlt'"
          @click="neuerStatus(selectRechnung, 'Gezahlt')"
          class="green"
          >Als Gezahlt markieren</v-btn
        >
        <v-btn
          rounded
          dark
          v-if="
            (selectRechnung.status === 'Überfällig' || selectRechnung.status === 'Gemahnt überfällig') &&
            allowRechnungBearbeiten
          "
          @click="showMahnung = true"
          class="red"
          >Mahnen</v-btn
        >
        <v-btn rounded text @click="close()">Schließen</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showBearbeiten" width="60%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          <v-chip color="green" label dark class="mr-2">Chargenansicht</v-chip>
          Rechnung {{ bearbeiteRechnung.rechnungsnummer }} bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showBearbeiten = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-8 text-center subtitle-1">
          <v-row class="ma-0 pa-0">
            <v-col cols="4">
              <v-text-field
                dense
                hide-details
                outlined
                type="text"
                label="Titel"
                v-model="bearbeiteRechnung.rechnung_titel"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                dense
                hide-details
                outlined
                :items="selectBbrBbr"
                label="Empfänger"
                v-model="bearbeiteRechnung.bbrID"
                disabled
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                hide-details
                outlined
                type="text"
                label="Rechnungsnummer"
                v-model="bearbeiteRechnung.rechnungsnummer"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                hide-details
                outlined
                type="date"
                label="Rechnungsdatum"
                v-model="bearbeiteRechnung.rechnung_datum"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                hide-details
                outlined
                type="date"
                label="Zahlbar bis"
                v-model="bearbeiteRechnung.rechnung_zahlbar_bis"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                dense
                hide-details
                outlined
                :items="statusItems"
                label="Status"
                v-model="bearbeiteRechnung.status"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                dense
                hide-details
                outlined
                rows="8"
                type="text"
                label="Text"
                v-model="bearbeiteRechnung.rechnung_freitext"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-card outlined>
                <v-simple-table dense fixed-header>
                  <tbody>
                    <tr v-for="(item, itemObjKey) in bearbeiteRechnung.positionen" :key="itemObjKey">
                      <td width="20px">{{ itemObjKey + 1 }}</td>
                      <td class="text-left">{{ item.was }}</td>
                      <td class="text-right">{{ item.betrag | money }}</td>
                      <td width="20px">
                        <v-btn
                          icon
                          @click="
                            (showEditPosition = true) && (neuePosition = item) && (selectedPositionIndex = itemObjKey)
                          "
                          ><v-icon>edit</v-icon></v-btn
                        >
                      </td>
                    </tr>
                    <tr>
                      <td width="20px"></td>
                      <td class="text-left"></td>
                      <td class="text-right pr-4 font-weight-bold">{{ bearbeiteRechnung.summe | money }}</td>
                      <td width="20px"></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12">Positionen können nur bearbeitet aber nicht hinzugefügt werden.</v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mb-6 mb-md-0">
          <v-btn text @click="showBearbeiten = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="updateRechnungData()" dark text>speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showEditPosition" width="50%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          Position bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showEditPosition = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="6"
              ><v-text-field
                dense
                hide-details
                outlined
                type="text"
                label="Bezeichnung"
                v-model="neuePosition.was"
              ></v-text-field
            ></v-col>
            <v-col cols="6"
              ><v-text-field
                v-if="neuePosition.positionen.length === 0"
                dense
                hide-details
                outlined
                type="number"
                label="Betrag"
                v-model="neuePosition.betrag"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-data-table
            v-if="neuePosition.positionen.length > 0"
            :items-per-page="neuePosition.positionen.length"
            dense
            fixed-header
            height="290"
            hide-default-footer
            :items="neuePosition.positionen"
            :headers="headersData"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td width="20px">{{ index + 1 }}</td>
                <td>
                  <v-text-field
                    dense
                    hide-details
                    class="text-right"
                    v-model="item.was"
                    label="Bezeichnung"
                    single-line
                    solo
                    flat
                    reverse
                  ></v-text-field>
                </td>
                <td width="120px">{{ $filters.date(item.datum.seconds * 1000) }}</td>
                <td width="120px">
                  <v-text-field
                    dense
                    hide-details
                    class="text-right"
                    prefix="€"
                    v-model="item.preis"
                    label="Betrag"
                    single-line
                    solo
                    flat
                    reverse
                  ></v-text-field>
                </td>
                <td width="20px"></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mb-6 mb-md-0">
          <v-spacer></v-spacer>
          <span class="pr-4 font-weight-bold">Summe: {{ summePosition | money }}</span>
          <v-btn @click="savePosition()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMahnung" width="50%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title v-if="selectRechnung.rechnungsnummer">
          Rechnung mahnen
          <v-spacer></v-spacer>
          <v-btn icon @click="showMahnung = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-checkbox
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                v-model="selectMahngebuehr"
                label="Mahngebühr hinzufügen?"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-text-field dense outlined type="number" label="Betrag" v-model="wertMahngebuehr"></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0" v-if="selectMahngebuehr">
              <v-radio-group v-model="artMahngebuehr" column>
                <v-radio on-icon="check_box" off-icon="check_box_outline_blank" label="Betrag" value="Betrag"></v-radio>
                <v-radio
                  on-icon="check_box"
                  off-icon="check_box_outline_blank"
                  label="Prozent"
                  value="Prozent"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
                dense
                outlined
                type="text"
                label="Zahlbar bis"
                hint="Format: 2022-03-21, Standart in 14 Tagen"
                v-model="mahnungUpdateData.rechnung_zahlbar_bis"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-textarea
                dense
                rows="3"
                v-model="mahnungUpdateData.rechnung_freitext"
                label="Freitext"
                hint="<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Mahnstufe>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>"
                auto-grow
                outlined
              ></v-textarea>
            </v-col>
            <v-col cols="12" class="py-0" v-if="selectMahngebuehr">
              Der Rechnung wird eine weitere Position hinzugefügt.<br />
              Mahngebühr: {{ wertMahngebuehr }} <span v-if="artMahngebuehr === 'Betrag'">€</span
              ><span v-if="artMahngebuehr === 'Prozent'">%</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mb-6 mb-md-0">
          <v-btn text @click="showMahnung = false">Schließen</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="mahnen(selectRechnung)" class="red">Mahnen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import JSPDF from "jspdf";
  export default {
    props: ["rechnungid", "visible"],
    data() {
      return {
        loading: false,
        mahnungUpdateData: {
          rechnung_zahlbar_bis: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().substr(0, 10),
          rechnung_freitext:
            "<<Briefanrede>> <<Nachname>>, \n\nhiermit bitte ich Dich die Rechnung <<Rechnungsnummer>> in der <<Mahnstufe>>. Mahnung in Höhe von <<Rechnungsbetrag>>€ bis zum <<Zahlbar_bis>> zu überweisen. \n \nMit bundesbrüderlichen Grüßen \nThomas Wieczorek \nBierwart",
        },
        showMahnung: false,
        selectMahngebuehr: false,
        artMahngebuehr: "Prozent",
        wertMahngebuehr: 10,
        showBearbeiten: false,
        showEditPosition: false,
        selectedPositionIndex: 0,
        neuePosition: {
          betrag: 0,
          positionen: [],
        },
        statusItems: ["Entwurf", "Entwurf SEPA", "Offen", "Gezahlt"],
        bearbeiteRechnung: "",
        headersData: [
          {
            text: "",
            sortable: false,
            value: "index",
          },
          { text: "Was", value: "was" },
          { text: "Datum", value: "datum" },
          { text: "Betrag", value: "preis" },
          { text: "", value: "" },
        ],
        logoUrl: null,
      };
    },
    mounted() {
      this.loadLogo();
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      settings() {
        return this.$store.getters["einstellungen/einstellung"]("allgemein");
      },
      allowRechnungBearbeiten() {
        let seiten = this.$store.getters["einstellungen/einstellung"]("rollen");
        let bbr = this.$store.state.bbrbbr.bbrbbr.find((d) => d.anmeldeID === this.$firebase.auth().currentUser.uid);
        let variable = false;
        if (seiten !== undefined) {
          seiten.seiten.forEach((item) => {
            if (
              item.titel === "Philisterquaestor" ||
              item.titel === "Quaestor" ||
              item.id === "Kassierer" ||
              item.titel === "Kassierer" ||
              item.id === "Bierwart" ||
              item.gruppe === "Philisterkassierer" ||
              item.gruppe === "HBV Kassierer"
            ) {
              if (item.berechtigt.indexOf(bbr.id) >= 0 || bbr.id === "PBChUyAy7HWowQR4HlP3") {
                variable = true;
              }
            }
          });
        }
        return variable;
      },
      selectBbrBbr() {
        let selectBbrBbr = [];
        this.$store.state.bbrbbr.bbrbbr.forEach((bbr) => {
          selectBbrBbr.push({
            id: bbr.id,
            value: bbr.id,
            name: bbr.nachname + ", " + bbr.vorname,
            text: bbr.nachname + ", " + bbr.vorname,
          });
        });
        return selectBbrBbr;
      },
      selectRechnung() {
        if (this.rechnungid) {
          let rechnung;
          rechnung = this.$store.getters["rechnungen/nutzerRechnung"](this.rechnungid);
          if (rechnung === undefined) {
            rechnung = this.$store.getters["rechnungen/rechnung"](this.rechnungid);
          }
          if (rechnung.positionen) {
            rechnung.positionen.forEach((position) => {
              if (Array.isArray(position.positionen)) {
                var result = [];
                position.positionen.reduce(function (res, value) {
                  if (!res[value.was]) {
                    res[value.was] = { datum: value.datum, anzahl: 0, was: value.was, preis: 0 };
                    result.push(res[value.was]);
                  }
                  res[value.was].preis += parseFloat(value.preis);
                  res[value.was].anzahl++;
                  return res;
                }, {});
                position.result = result;
                position.positionen.sort(function (a, b) {
                  return a.datum.seconds - b.datum.seconds;
                });
              } else {
                position.positionen = [];
              }
            });
          }
          return rechnung;
        } else {
          let rechnungen = {
            rechnungsnummer: "",
            positionen: [],
            rechnung_datum: "",
            rechnung_freitext: "",
            rechnung_zahlbar_bis: "",
            bbr: "",
          };
          return rechnungen;
        }
      },
      summePosition() {
        let summe = 0;
        if (this.neuePosition.positionen.length > 0) {
          this.neuePosition.positionen.forEach((item) => {
            summe += parseFloat(item.preis);
          });
        } else {
          summe = parseFloat(this.neuePosition.betrag);
        }
        this.neuePosition.betrag = summe.toFixed(2);
        return summe;
      },
    },
    methods: {
      async loadLogo() {
        try {
          const url = await this.logoImage();
          this.logoUrl = url;
        } catch (error) {
          console.error("Error loading logo:", error);
        }
      },
      async logoImage() {
        try {
          const storagePath = `/design/logo/${this.$vars.verbindung}`;
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL();
          return url;
        } catch (error) {
          console.error(error);
          throw error; // Rethrow the error to be caught in the calling function
        }
      },
      savePosition() {
        this.bearbeiteRechnung.positionen[this.selectedPositionIndex] = this.neuePosition;
        let summe = 0;
        this.bearbeiteRechnung.positionen.forEach((item) => {
          summe += parseFloat(item.betrag);
        });
        this.bearbeiteRechnung.summe = summe.toFixed(2);
        this.showEditPosition = false;
      },
      neuerStatus(selectRechnung, status) {
        if (status === "") {
          return;
        } else {
          selectRechnung.status = status;
          this.$store.dispatch("rechnungen/updateRechnungData", selectRechnung);
        }
      },
      ersetzeText(text, rechnung) {
        let summe = 0;
        rechnung.positionen.forEach((position) => {
          summe = parseFloat(summe) + parseFloat(position.betrag);
        });
        text = text.replace("<<Rechnungstitel>>", rechnung.rechnung_titel);
        text = text.replace(
          "<<Rechnungsdatum>>",
          new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        text = text.replace("<<Rechnungsnummer>>", rechnung.rechnungsnummer);
        text = text.replace("<<Mahnstufe>>", rechnung.mahnstufe);
        text = text.replace("<<Briefanrede>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).briefanrede);
        text = text.replace("<<Vorname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).vorname);
        text = text.replace("<<Nachname>>", this.$store.getters["bbrbbr/bbr"](rechnung.bbrID).nachname);
        text = text.replace("<<Rechnungsbetrag>>", summe.toFixed(2));
        text = text.replace(
          "<<Zahlbar_bis>>",
          new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })
        );
        return text;
      },
      mahnen(selectRechnung, status) {
        if (this.selectMahngebuehr) {
          let betrag;
          if (this.artMahngebuehr === "Betrag") {
            betrag = parseFloat(this.wertMahngebuehr).toFixed(2);
          }
          if (this.artMahngebuehr === "Prozent") {
            betrag = parseFloat((selectRechnung.summe / 100) * parseFloat(this.wertMahngebuehr)).toFixed(2);
          }
          if (!selectRechnung.mahnstufe) {
            selectRechnung.mahnstufe = 1;
          } else {
            selectRechnung.mahnstufe++;
          }
          selectRechnung.positionen.push({
            was: selectRechnung.mahnstufe + ". Mahnung",
            betrag,
          });
          selectRechnung.summe = (parseFloat(selectRechnung.summe) + parseFloat(betrag)).toFixed(2);
          selectRechnung.summe = parseFloat(selectRechnung.summe);
        }
        selectRechnung.rechnung_zahlbar_bis = this.mahnungUpdateData.rechnung_zahlbar_bis;
        selectRechnung.rechnung_titel = selectRechnung.rechnung_titel;
        selectRechnung.status = "Mahnung";
        selectRechnung.rechnung_freitext = this.ersetzeText(this.mahnungUpdateData.rechnung_freitext, selectRechnung);
        this.$store.dispatch("rechnungen/updateRechnungData", selectRechnung);
        this.rechnungVersenden();
        this.showMahnung = false;
        this.visible = false;
      },
      updateRechnungData() {
        this.showBearbeiten = false;
        this.bearbeiteRechnung.summe = parseFloat(this.bearbeiteRechnung.summe);
        this.$store.dispatch("rechnungen/updateRechnungData", this.bearbeiteRechnung);
        this.bearbeiteRechnung = "";
      },
      rechnungVersenden() {
        // Mail verschicken
        let rechnung = this.selectRechnung;
        if (rechnung.farbe === undefined) {
          rechnung.farbe = "";
        }
        rechnung.rechnung_freitext_code = rechnung.rechnung_freitext.replace(/(?:\r\n|\r|\n)/g, "<br>");
        let bundesbruder = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
        let absender = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
        let position = null;
        if (this.$route.params.seite !== undefined) {
          position = this.$route.params.seite;
        }
        if (bundesbruder.email) {
          this.$store.dispatch("mails/createEinMails", {
            art: "rechnung",
            rechnung,
            to: [bundesbruder.email],
            an: [bundesbruder.id],
            absender: {
              position,
              name: absender.vorname + " " + absender.nachname,
              adresse: absender.adresse,
              plz: absender.plz,
              ort: absender.ort,
              email: absender.email,
              telefon: absender.handy,
            },
            message: {
              subject: rechnung.rechnung_titel,
              text: rechnung.rechnung_freitext_code,
            },
            datum: new Date(),
          });
          this.$store.state.snackbar = {
            show: true,
            nachricht: "Rechnung wurde per Mail versendet.",
          };
        } else {
          this.printRechnung(this.selectRechnung);
          this.$store.state.snackbar = {
            show: true,
            nachricht: "Keine Mailadresse hinterlegt. Rechnung wurde als PDF gespeichert.",
          };
        }
      },
      close() {
        this.$emit("close", false);
      },
      printRechnung(item) {
        let rechnung = item;
        let kasse = this.$store.getters["einstellungen/einstellung"]("kassen")[rechnung.kasse];
        let bbr = this.$store.getters["bbrbbr/bbr"](rechnung.bbrID);
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
        doc.rect(0, 90, 210, 1, "F");
        if (this.$vars.verbindung === "rbo") {
          doc.setFillColor(
            this.settings.secondary.rgba.r,
            this.settings.secondary.rgba.g,
            this.settings.secondary.rgba.b
          );
          doc.rect(0, 92, 210, 1, "F");
          let img = new Image();
          img.src = this.logoUrl;
          doc.addImage(img, 125, 30, 75, 75);
        }
        doc.setFontSize(9);
        doc.text(
          this.settings.name +
            " | " +
            this.settings.strasse +
            " " +
            this.settings.hausnummer +
            " | " +
            this.settings.plz +
            " " +
            this.settings.ort,
          25,
          51
        );
        doc.setFontSize(11);
        if (bbr.titel) {
          doc.text(bbr.anrede + " " + bbr.titel, 25, 61);
        } else {
          doc.text(bbr.anrede, 25, 61);
        }
        doc.text(bbr.vorname + " " + bbr.nachname, 25, 66);
        doc.text(bbr.adresse, 25, 71);
        doc.text(bbr.plz + " " + bbr.ort, 25, 76);
        doc.text(bbr.land, 25, 81);
        doc.setFont("Times", "bold");
        doc.text("Rechnungsnr.", 20, 110);
        doc.text("Datum", 70, 110);
        if (rechnung.rechnung_art === "SEPA") {
          doc.text("Einzug am", 120, 110);
        } else {
          doc.text("Zahlbar bis", 120, 110);
        }
        doc.text("Kasse", 170, 110);
        doc.setFont("Times", "normal");
        doc.text(rechnung.rechnungsnummer, 20, 115);
        doc.text(
          new Date(rechnung.rechnung_datum).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          }),
          70,
          115
        );
        doc.text(
          new Date(rechnung.rechnung_zahlbar_bis).toLocaleString(["de-de"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
          }),
          120,
          115
        );
        doc.text(rechnung.kasse, 170, 115);
        doc.setFont("Times", "bold");
        doc.text(rechnung.rechnung_titel, 210, 125);
        doc.setFont("Times", "normal");
        let lines1 = doc.splitTextToSize(rechnung.rechnung_freitext, 168);
        doc.text(lines1, 20, 130);
        let zeile = 130 + parseInt(parseInt(6) * lines1.length);
        doc.setFont("Times", "bold");
        zeile = parseInt(zeile) + 5;
        doc.text("Pos", 20, zeile);
        doc.text("Beschreibung", 31, zeile);
        doc.text("Betrag", 190, zeile, { align: "right" });
        doc.setFont("Times", "normal");
        zeile = parseInt(zeile) + 2;
        doc.line(20, zeile, 190, zeile);
        zeile = parseInt(zeile) + 6;
        let pos = "1";
        let summe = 0;
        rechnung.positionen.forEach((position) => {
          doc.text(pos, 20, zeile);
          doc.text(position.was, 31, zeile);
          doc.text(parseFloat(position.betrag).toFixed(2) + " €", 190, zeile, { align: "right" });
          summe = summe + parseFloat(position.betrag);
          zeile = parseInt(zeile) + 10;
          pos = String(parseInt(pos) + 1);
        });
        doc.line(20, zeile - 4, 190, zeile - 4);
        doc.setFont("Times", "bold");
        zeile = parseInt(zeile) + 1;
        doc.text("Summe " + summe.toFixed(2) + " €", 190, zeile, { align: "right" });
        doc.setFont("Times", "normal");
        zeile = parseInt(zeile) + 2;
        doc.line(159, zeile, 190, zeile);
        zeile = parseInt(zeile) + 1;
        doc.line(159, zeile, 190, zeile);
        doc.setFontSize(9);

        doc.setFillColor(this.settings.primary.rgba.r, this.settings.primary.rgba.g, this.settings.primary.rgba.b);
        doc.rect(0, 265, 210, 297, "F");
        doc.setFontSize(10);
        doc.setTextColor(230, 230, 230);
        doc.setFont("Times", "bold");
        doc.text(this.settings.name, 60, 272, { align: "center" });
        doc.setFont("Times", "normal");
        doc.text(rechnung.kasse, 60, 280, { align: "center" });
        doc.text(this.settings.strasse + " " + this.settings.hausnummer, 60, 285, { align: "center" });
        doc.text(this.settings.plz + " " + this.settings.ort, 60, 290, { align: "center" });
        doc.setFont("Times", "bold");
        doc.text("Bankverbindung", 150, 272, { align: "center" });
        doc.setFont("Times", "normal");
        doc.text(kasse.kontoname, 150, 280, { align: "center" });
        doc.text(kasse.IBAN, 150, 285, { align: "center" });
        doc.text(kasse.BIC, 150, 290, { align: "center" });

        doc.save("Rechnung-" + rechnung.rechnungsnummer + "-" + bbr.nachname + "-" + bbr.vorname + ".pdf");
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// dialogRechnung.vue?5d85628a